/**
 * Representa um endereço postal brasileiro retornado pela API ViaCEP.
 * @hideconstructor
 */
export class Address {
  /** Código de Endereçamento Postal. */
  private _cep: string;
  /** Nome do logradouro (rua, avenida, etc.). */
  private _logradouro: string;
  /** Complemento do endereço (apto, bloco, etc.). */
  private _complemento: string;
  /** Unidade do logradouro, quando aplicável. */
  private _unidade: string;
  /** Nome do bairro. */
  private _bairro: string;
  /** Nome do município. */
  private _localidade: string;
  /** Sigla da unidade federativa (estado). */
  private _uf: string;
  /** Nome completo do estado. */
  private _estado: string;
  /** Nome da macrorregião geográfica do Brasil. */
  private _regiao: string;
  /** Código IBGE do município. */
  private _ibge: string;
  /** Código GIA — Gerência de Informação Apurada (somente municípios de SP). */
  private _gia: string;
  /** Código DDD da área de telefonia. */
  private _ddd: string;
  /** Código SIAFI do município. */
  private _siafi: string;

  protected constructor(
    cep: string,
    logradouro: string,
    complemento: string,
    unidade: string,
    bairro: string,
    localidade: string,
    uf: string,
    estado: string,
    regiao: string,
    ibge: string,
    gia: string,
    ddd: string,
    siafi: string
  ) {
    this._cep = cep;
    this._logradouro = logradouro;
    this._complemento = complemento;
    this._unidade = unidade;
    this._bairro = bairro;
    this._localidade = localidade;
    this._uf = uf;
    this._estado = estado;
    this._regiao = regiao;
    this._ibge = ibge;
    this._gia = gia;
    this._ddd = ddd;
    this._siafi = siafi;
  }
  /** Código de Endereçamento Postal (CEP). */
  get cep() {
    return this._cep;
  }
  /** Nome do logradouro (rua, avenida, travessa, etc.). */
  get logradouro() {
    return this._logradouro;
  }
  /** Complemento do endereço (apartamento, bloco, etc.). */
  get complemento() {
    return this._complemento;
  }
  /** Unidade do logradouro, quando disponível. */
  get unidade() {
    return this._unidade;
  }
  /** Nome do bairro. */
  get bairro() {
    return this._bairro;
  }
  /** Nome do município. */
  get localidade() {
    return this._localidade;
  }
  /** Sigla da unidade federativa (estado). */
  get uf() {
    return this._uf;
  }
  /** Nome completo do estado. */
  get estado() {
    return this._estado;
  }
  /** Nome da macrorregião geográfica do Brasil (Norte, Nordeste, etc.). */
  get regiao() {
    return this._regiao;
  }
  /** Código IBGE do município. */
  get ibge() {
    return this._ibge;
  }
  /** Código GIA — Gerência de Informação Apurada (somente municípios de SP). */
  get gia() {
    return this._gia;
  }
  /** Código DDD da área de telefonia. */
  get ddd() {
    return this._ddd;
  }
  /** Código SIAFI do município. */
  get siafi() {
    return this._siafi;
  }

  /**
   * Cria uma instância de Address a partir de um objeto bruto retornado pela API ViaCEP.
   * @param raw Objeto JSON retornado pela API
   * @returns Instância de Address com os campos mapeados
   */
  static from(raw: Record<string, string>): Address {
    return new Address(
      raw['cep'],
      raw['logradouro'],
      raw['complemento'],
      raw['unidade'],
      raw['bairro'],
      raw['localidade'],
      raw['uf'],
      raw['estado'],
      raw['regiao'],
      raw['ibge'],
      raw['gia'],
      raw['ddd'],
      raw['siafi']
    );
  }
}
